<div class="container-fluid">
    <div class="row g-6 mb-6">
        <div class="col-xl-12">
            <div class="mainContainer card overflow-auto margin mt-4">
                <div class="loader" *ngIf="loading">
                    <mat-spinner diameter="30"></mat-spinner>
                </div>
                <div class="reminder mb-0 d-flex bg-light justify-content-between flex-column flex-sm-row">
                    <h5 class="card-title ps-4 mb-0 tableTitle">Email Logs</h5>

                    <div class="d-flex align-items-center ms-auto me-4 gap-2">

                        <!-- Search box -->
                        <div class="input-group input-group-sm input-group-inline" style="width: 180px; height: 35px;">
                            <span class="input-group-text pe-2"><i class="bi bi-search"></i></span>
                            <input type="text" class="form-control form-control-sm" placeholder="Search Email Logs"
                                aria-label="Search" [(ngModel)]="emailLogSearch" (keyup)="searchEmaiLog()">
                        </div>

                        <!-- Month dropdown -->
                        <select class="form-select form-select-sm" style="width: 180px; height: 35px;"
                            [(ngModel)]="selectedMonth" (change)="searchEmaiLog()">
                            <option [ngValue]="null">Month</option>
                            <option *ngFor="let month of months" [value]="month.value">{{ month.name }}</option>
                        </select>

                        <!-- Year dropdown -->
                        <select class="form-select form-select-sm" style="width: 180px; height: 32px;"
                            [(ngModel)]="selectedYear" (change)="searchEmaiLog()">
                            <option [ngValue]="null">Year</option>
                            <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                        </select>

                    </div>
                </div>
                <table matSort class="table table-hover table-nowrap">
                    <thead class="table-light">
                        <tr>
                            <th mat-sort-header="to" scope="col">To</th>
                            <th mat-sort-header="subject" scope="col">Subject</th>
                            <th mat-sort-header="sent_at" scope="col">Sent At</th>
                            <th mat-sort-header="email" scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="emailLogs.length > 0">
                            <tr class="dataColumn" *ngFor="let emailLog of emailLogs">
                                <td>{{emailLog.to}}</td>
                                <td>{{emailLog.subject}}</td>
                                <td>{{dataSharedService.transformTimeDate(emailLog.sent_at)}}</td>
                                <td>
                                    <div (click)="viewEmailLog(emailLog)" style="color: #6b7b93;"
                                        class="btn btn-neutral btn-sm bt-square ms-1 px-3 py-1 fs-7"
                                        matTooltip="View Email Content" [matTooltipPosition]="'left'">
                                        <i class="bi bi-eye"></i>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="emailLogs.length == 0">
                            <tr>
                                <td class="text-heading font-bold text-center">No records found</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
                <app-api-paginator *ngIf="totalCount" [totalCount]="totalCount" (onStepChange)="onStepChange($event)">
                </app-api-paginator>
            </div>


        </div>
    </div>
</div>